/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {TabCentralModel} from '../../../../../../models'
import {EnterpriseModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {getEnterprise} from '../../../../services'

const TableEnterprise: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const getEnterpriseList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getEnterprise(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getEnterpriseList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getEnterpriseList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-enterprise',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<EnterpriseModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de documento' name={'ruc'} searcheable />
        ),
        accessor: 'ruc',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Razón social' name={'nombre'} searcheable />
        ),
        accessor: 'nombre',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono 1' name={'telefono1'} searcheable />
        ),
        accessor: 'telefono1',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Dirección 1' name={'direccion1'} searcheable />
        ),
        accessor: 'direccion1',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}
export {TableEnterprise}
